var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 11.75H10.125V6.5H5.75V11.75ZM0.5 11.75H4.875V0.375H0.5V11.75ZM11 11.75H15.375V6.5H11V11.75ZM5.75 0.375V5.625H15.375V0.375H5.75Z",
    fill: "#1CD4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoType);
export default __webpack_public_path__ + "static/media/picto-type.47f1400ab3204023f333b2c34144250b.svg";
export { ForwardRef as ReactComponent };